import { render, staticRenderFns } from "./ReportsCard.vue?vue&type=template&id=18b46afe&scoped=true&"
import script from "./ReportsCard.vue?vue&type=script&lang=js&"
export * from "./ReportsCard.vue?vue&type=script&lang=js&"
import style1 from "./ReportsCard.vue?vue&type=style&index=1&id=18b46afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b46afe",
  null
  
)

export default component.exports